// The transaction-list API (/accounts/transaction-list/) uses cursor pagination:
// { next, previous, results } instead of page-number pagination. "next"/"previous"
// are full URLs — pull the cursor query param out so it can be re-sent as a param
// on the next request through axiosInstance (keeping baseURL/auth interceptors).
export const extractCursor = (url) => {
  if (!url) return null;
  try {
    return new URL(url).searchParams.get("cursor");
  } catch {
    return null;
  }
};
